<!-- @format -->
<current-reward>

    <div class="container_pay">
        <p class="pay_heading">今月の報酬確定額</p>
        <div class="wrap_pay">
            <p class="pay"><span class="pay-amount"><number-format number={state.rewardInThisMonth} /></span>円(税込)</p>
            <p class="note">※報酬額のお支払いは月末締めの翌月20日支払い（休日の場合は翌営業日）となります。</p>
            <p class="note">※振込先はお支払い月の1日未明に登録されている銀行口座へ入金となります。</p>
        </div><!--/.wrap_pay-->
    </div><!--/.container_pay-->
  <script>
    import di from "dependeny-injection";

    export default {
      state: {
        rewardInThisMonth: 0,
      },
      fetchRewardInThisMonth(){
        this.api.request('history', 'fetch-reward-in-this-month')
          .then(data=>this.update({rewardInThisMonth: data}));
      },
      onBeforeMount(props, state){
        this.api = di.createApi('project');
        this.fetchRewardInThisMonth();
      },
    };
  </script>
</current-reward>
